import React from "react"
import { Link } from "react-router-dom"
import {
  Box,
  Button,
  Flex,
  Image,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react"
import { useMediaQuery } from "@chakra-ui/media-query"

function Mainview() {

  const [mobileView] = useMediaQuery('(min-width: 450px)')

  return (
    <Flex
      align="center"
      justify={{ base: "center", md: "space-around", xl: "space-between" }}
      direction={{ base: "column-reverse", md: "row" }}
      wrap="no-wrap"
      minH="70vh"
      px={8}
      mb={16}
      
    >
      <Stack
        spacing={4}
        w={{ base: "80%", md: "40%" }}
        align={["center", "center", "flex-start", "flex-start"]}
      >
        {mobileView ? <Heading
          as="h1"
          size="2xl"
          fontWeight="bold"
          color="primary.800"
          textAlign={["center", "center", "left", "left"]}
        >
          Discover, Mint and Collect {<br />}  NFTs on the first ever {<br/>} <font color='#F2545B'> revenue sharing </font> marketplace. 
        </Heading>:
          <Heading
            as="h1"
            size="xl"
            fontWeight="bold"
            color="primary.800"
            textAlign='center'
          >
            first ever <font color='#F2545B'> revenue sharing </font> nft marketplace.
          </Heading>
        }
        
      {mobileView ? <Text
          as="h2"
          size="md"
          color="primary.800"
          opacity="0.8"
          fontWeight="normal"
          lineHeight={1.5}
          textAlign={["center", "center", "left", "left"]}
        >
          Your go-to marketplace to have that extra pocket money!
        </Text> : <br/>}
        
        <Link to='/nfts'>
          <Button
            colorScheme="primary"
            borderRadius="8px"
            py="4"
            px="4"
            lineHeight="1"
            size="md"
            rounded="50"
            height='12'
            backgroundColor="#F2545B"
            _hover="false"
            _focus="none"
            _active={{
                textColor: "#F2545B",
                backgroundColor: "white"}}
          >
            Taste the eclair
          </Button>
        </Link>
      </Stack>
      <Box w={{ base: "80%", sm: "90%", md: "50%" }} mb={{ base: 12, md: 0 }} position='relative' bottom='0' right='0'>
        <Image src='https://picsum.photos/400?random=1' alt='mainview' position='absolute' bottom='-10%' right='-10%' rounded='20'/>
        <Image src='https://picsum.photos/400?random=2' alt='mainview' position='relative' bottom='0' right='0' rounded='20'/>
        <Image src='https://picsum.photos/400?random=3' alt='mainview' position='absolute' bottom='10%' right='10%' rounded='20'/>
      </Box>
    </Flex>
  )
}

export default Mainview;